<template lang="pug">
    multiselect(
        label="name"
        :options="distributorList"
        :loading="onLoading('get-outlet-distributor')"
        @select="onSelect"
        :placeholder="placeholder"
        v-model="value"
        :allow-empty="false"
        :internal-search="false"
        @search-change="loadDistributors"
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        placeholder: {
            type: String,
            default: 'Select Distributor',
        },
    },

    data() {
        return {
            value: null,
        };
    },

    computed: {
        ...mapGetters('inventoryDistributor', ['outlet']),

        distributorList() {
            return this.outlet.distributors;
        },
    },

    watch: {
        '$store.getters.activeOutlet'() {
            this.getOutletDistributors({
                outletId: this.$store.getters.activeOutlet,
                params: {
                    limit: 15,
                },
            });
        },
    },

    mounted() {
        this.getOutletDistributors({
            outletId: this.$store.getters.activeOutlet,
            params: {
                limit: 15,
            },
        });
    },

    methods: {
        ...mapActions('inventoryDistributor', ['getOutletDistributors']),

        onSelect(distributor) {
            this.$emit('input', distributor);
        },

        loadDistributors: _.debounce(function(query) {
            this.getOutletDistributors({
                outletId: this.$store.getters.activeOutlet,
                params: {
                    limit: 15,
                    query,
                },
            });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/distributor-selector.vue